// Recovered compiled webpack factory 14356. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  function n() {
    return "undefined" != typeof __SENTRY_BROWSER_BUNDLE__ && !!__SENTRY_BROWSER_BUNDLE__;
  }
  function a() {
    return "npm";
  }
  r.d(t, { Z: () => n, e: () => a });
}
